import { baseReportUrl } from 'environments'
import { createActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.jobAuditReport, {
  basePath: 'report/jobReports',
  baseUrl: baseReportUrl,
})
